import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import RadixDialog from '../../../../../shared/RadixDialog';
import { ChangeDate } from '../ChangeDate.jsx';
import { useCreatePostMutation } from './usePostMutation';
import { CREATE } from '../../../utils/constants';

export const useCreatePost = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentCampaignId, setCurrentCampaignId] = useState(null);
  const { createPostMutation } = useCreatePostMutation();
  const { t } = useTranslation('posts');

  const openCreatePostModal = campaignId => {
    setCurrentCampaignId(campaignId);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setCurrentCampaignId(null);
  };

  const handleSave = ({ publishDate, sendHour }) => {
    createPostMutation({
      publish_date: publishDate,
      campaignId: currentCampaignId,
      sendHour,
    });
    handleClose();
  };

  const CreatePostModal = () => {
    if (!isOpen) return null;

    return (
      <RadixDialog
        isOpen={isOpen}
        onClose={handleClose}
        title={t('setPostDate')}
      >
        <ChangeDate
          campaignId={currentCampaignId}
          origin={CREATE}
          handleCancel={handleClose}
          handleSave={handleSave}
        />
      </RadixDialog>
    );
  };

  return { openCreatePostModal, CreatePostModal };
};
